<template>
  <el-container>
    <el-header class="table-header">
      <el-button type="primary" size="small" @click="insert">{{$t('common.Add')}}</el-button>
    <el-button icon="el-icon-search" align="center" size="small" @click="search('refresh')">{{$t('common.Search')}}</el-button>
    <el-button icon="el-icon-refresh-left" align="center" size="small" @click="reset">{{$t('common.Reset')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="formSearch" label-width="80px" size="mini" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.functions.functionName')">
              <el-input v-model="formSearch.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Status')">
              <el-select v-model="formSearch.status">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column type="index">
        </el-table-column>
        <el-table-column prop="name" :label="$t('base.info.functions.functionName')" align="center" width="100%">
        </el-table-column>
        <el-table-column prop="prefix" :label="$t('base.info.functions.Prefix')" align="center" width="80%">
        </el-table-column>
        <el-table-column prop="status" :label="$t('common.Status')" width="100%" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status===50" size="small">{{$t('common.Normal')}}</span>
            <span v-if="scope.row.status===40" size="small">{{$t('common.Disable')}}</span>
            <span v-if="scope.row.status===10" size="small">{{$t('common.Draft')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('common.Remark')" align="center">
      </el-table-column>
        <el-table-column prop="createTime" :label="$t('common.CreateTime')" :formatter="changeTime" align="center">
        </el-table-column>
        <el-table-column width="200%" align="center" :label="$t('common.Operate')">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">{{$t('common.Edit')}}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(scope.row)">{{$t('common.Delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="table-footer">
      <table-page ref="functionListPage" :url="functionListUrl" :form="formSearch" @page-change="convert"></table-page>
    </el-footer>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :before-close="handleClose" :close-on-click-modal="false" width="30%">
      <el-form ref="form" :rules="CommitForm" :model="form" size="mini" label-width="80px" class="table-form">
        <el-form-item :label="$t('base.info.functions.functionId')" prop="functId" v-if="title===this.$t('base.info.functions.AddFunction')">
          <el-input v-model="form.functId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base.info.functions.functionName')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base.info.functions.Prefix')" prop="prefix">
          <el-input v-model="form.prefix"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.Status')" prop="status">
          <el-radio :label="10" v-model="form.status">{{$t('common.Draft')}}</el-radio>
          <el-radio :label="40" v-model="form.status">{{$t('common.Disable')}}</el-radio>
          <el-radio :label="50" v-model="form.status">{{$t('common.Normal')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('common.Remark')" prop="remark">
          <el-input v-model="form.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="comfirm(form)">{{$t('common.Ok')}}</el-button>
        <el-button @click="cancel" size="mini">{{$t('common.Cancel')}}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from 'moment'
import TablePage from '@/components/TablePage'

export default {
  data () {
    return {
      tableData: [],
      form: {
        functId: '',
        name: '',
        status: 50,
        prefix: '',
        remark: ''
      },
      formSearch: {
        name: '',
        status: ''
      },
      dialogFormVisible: false,
      functionListUrl: this.global.BASE_ACL + '/function/findAllFunction',
      title: ''
    }
  },
  components: {
    TablePage
  },
  methods: {
    changeTime (row, column) {
      let date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    handleEdit (row) {
      this.dialogFormVisible = true
      this.form.prefix = row.prefix
      this.form.functId = row.functId
      this.form.name = row.name
      this.form.status = row.status
      this.form.remark = row.remark
      this.title = this.$t('base.info.functions.EditFunction')
    },
    insert () {
      this.dialogFormVisible = true
      this.title = this.$t('base.info.functions.AddFunction')
    },
    handleClose () {
      this.cancel()
    },
    cancel () {
      this.form = {
        functId: '',
        name: '',
        prefix: '',
        status: 50,
        remark: ''
      }
      this.$refs['form'].resetFields()
      this.dialogFormVisible = false
    },
    comfirm (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false
          if (this.title === '修改功能信息') {
            this.update(form)
          }
          if (this.title === '新增功能') {
            this.createfunc(form)
          }
        }
      })
    },
    update (form) {
      let param = {
        data: form
      }
      this.$api.functionList.functionUpdate(param).then((response) => {
        this.$refs['functionListPage'].getTableData()
        this.cancel()
        if (response.data.status === 'Y') {
          this.$message({
            message: response.data.message,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.data.message,
            type: 'error'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
        this.$message({
          type: 'primary',
          message: '失败'
        })
      })
    },
    createfunc (form) {
      let param = {
        data: form
      }
      this.$api.functionList.functionInsert(param).then((response) => {
        this.$refs['functionListPage'].getTableData()
        this.cancel()
        if (response.data.status === 'Y') {
          this.$message({
            message: response.data.message,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.data.message,
            type: 'error'
          })
        }
      }).catch((error) => {
        console.log(error)
        this.$message({
          type: 'primary',
          message: '失败'
        })
      })
    },
    deleteRow (data) {
      this.$confirm(this.$t('common.DeleteConfirm'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.functionList.functionDelete(this.qs.stringify({functId: data.functId})).then((response) => {
          if (response.data.status === 'Y') {
            this.$message({
              message: response.data.message,
              type: 'success'
            })
          } else {
            this.$message({
              message: response.data.message,
              type: 'error'
            })
          }
          this.$refs['functionListPage'].getTableData()
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.Cancel')
        })
      })
    },
    search (param) {
      this.$refs['functionListPage'].getTableData(param)
    },
    reset () {
      this.formSearch = {}
    },
    convert (table) {
      this.tableData = table.data
    }
  },
  computed: {
    options () {
      let arry = []
      arry.push({'value': '', 'label': this.$t('common.PleaseChoose')})
      arry.push({'value': 10, 'label': this.$t('common.Draft')})
      arry.push({'value': 40, 'label': this.$t('common.Disable')})
      arry.push({'value': 50, 'label': this.$t('common.Normal')})
      return arry
    },
    CommitForm () {
      return {
        name: [{required: true, trigger: 'blur', message: this.$t('common.NotEmpty')}],
        prefix: [{required: true, trigger: 'blur', message: this.$t('common.NotEmpty')}],
        remark: [{max: 90, message: this.$t('common.OverLength')}]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/functionList.vue